var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMediaFiles = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M54.136 82.757v124.026h143.107v19.081H54.136c-10.524 0-19.081-8.557-19.081-19.08V82.756zm156.597-28.621 34.212 34.212v80.273c0 10.524-8.557 19.081-19.08 19.081H92.297c-10.524 0-19.081-8.557-19.081-19.08V73.216c0-10.514 8.557-19.081 19.08-19.081zm-13.49 19.08H92.298v95.405h133.576l-.01-66.783h-28.621zM130.46 92.299l57.242 28.621-57.242 28.621z"
})));
export default SvgMediaFiles;